import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PENDING_KEY = "asa_pending_payment";

// Start a subscription checkout (register or upgrade). Stores pending context,
// then redirects the browser to Stripe Checkout.
export async function startSubscriptionCheckout({ tier, billing, kind, email, extra = {} }) {
  localStorage.setItem(PENDING_KEY, JSON.stringify({ kind, tier, billing, email, ...extra }));
  const origin = window.location.origin;
  const { data } = await axios.post(`${API}/payments/checkout/subscription`, {
    tier, billing, kind, email, origin_url: origin,
  });
  window.location.href = data.url;
}

// Start a one-off download checkout.
export async function startDownloadCheckout({ downloadId, title, email, returnTo }) {
  localStorage.setItem(PENDING_KEY, JSON.stringify({ kind: "download", downloadId, title, returnTo }));
  const origin = window.location.origin;
  const { data } = await axios.post(`${API}/payments/checkout/download`, {
    download_id: downloadId, email, origin_url: origin,
  });
  window.location.href = data.url;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/checkout/status/${sessionId}`);
  return data;
}

export function readPending() {
  try { return JSON.parse(localStorage.getItem(PENDING_KEY) || "{}"); } catch { return {}; }
}
export function clearPending() { localStorage.removeItem(PENDING_KEY); }
